import { americanToDecimal } from "@/utils/calculators/odds-utils";
import { getEdgeSupportingLiquidity, getWhaleDemandFromOpposite, recomputeEdgePercent, type BookData, type MarketOpportunity, type PeerOdds, type Side } from "@/lib/whale-watch/whale-watch-shared";

function postedOrders(levels: { odds: number; money: number }[]): BookData {
  const order_book = levels.map(({ odds, money }) => ({ odds: americanToDecimal(-odds), liquidity: money * odds / 100 }));
  return {
    odds_american: -levels[0].odds,
    odds_decimal: order_book[0].odds,
    liquidity: order_book[0].liquidity,
    total_liquidity: order_book.reduce((sum, level) => sum + level.liquidity, 0),
    actual_money_at_risk: levels.reduce((sum, level) => sum + level.money, 0),
    order_book,
  };
}

const oppositeBooks = {
  prophetx: postedOrders([{ odds: 111, money: 800 }, { odds: 112, money: 1400 }]),
  novig: postedOrders([{ odds: 113, money: 2900 }]),
};
const play: Side<PeerOdds> = {
  name: "Florida International", line: 4.5, side: "home", total_liquidity: 120, actual_money_at_risk: 0, pinnacle_limit: 0,
  books: { kalshi: { odds_american: 114, odds_decimal: 2.14, liquidity: 120, total_liquidity: 120, actual_money_at_risk: 0 } },
  peers: [{ book: "kalshi", odds_american: 114, odds_decimal: 2.14, limit: 120 }],
  best_odds: 114, best_book: "kalshi", edge_percent: recomputeEdgePercent(oppositeBooks, 114), demand: getWhaleDemandFromOpposite(oppositeBooks),
};
const oppositeLiquidity = Object.values(oppositeBooks).reduce((sum, book) => sum + (book.total_liquidity ?? 0), 0);
const opposite: Side<PeerOdds> = {
  name: "Florida Atlantic", line: -4.5, side: "away", total_liquidity: oppositeLiquidity, actual_money_at_risk: 5100, pinnacle_limit: 0,
  books: oppositeBooks, peers: [], best_odds: -111, best_book: "prophetx", demand: getWhaleDemandFromOpposite(play.books),
};

export const PRACTICE_WHALE: MarketOpportunity<PeerOdds> = {
  id: "practice-fiu-spread", event_id: "practice-fiu", event: "Florida International vs Florida Atlantic",
  event_start: "2026-09-26T19:30:00Z", updated_at: "2026-09-22T16:00:00Z",
  home_team: "Florida International", away_team: "Florida Atlantic", league: "CFB", sport: "Football", market_type: "spread",
  market: {
    market: "Point Spread", line: 4.5, sides: [play, opposite], total_liquidity: oppositeLiquidity + 120, pinnacle_limit: 0,
    edge_supporting_liquidity: getEdgeSupportingLiquidity(oppositeBooks, 114), same_side_conviction_liquidity: 5100,
  },
};

export const WHALE_PRACTICE_TICKET = {
  id: PRACTICE_WHALE.id,
  game: PRACTICE_WHALE.event,
  outcome: "Florida International +4.5",
  kind: "Spread" as const,
  price: 47,
  quotedOdds: play.best_odds,
  contracts: Math.floor(play.total_liquidity * 100 / 47),
  slug: "fiu-spread",
  settlement: "Yes pays $1 per contract if Florida International wins or loses by 4 points or fewer, including overtime; otherwise Yes pays $0.",
};
